import React, { useEffect, useRef, useState } from 'react';
import { Body, Header, IconWrapper, Wrapper } from './side-accordion.styles';
import { AllEye, AllEyeClose } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '../../config/colors/colors';
import { WRAPPER_GAP, WRAPPER_PADDING } from './constants';
import { SideAccordionProps } from './types';

export const SideAccordion: React.FC<SideAccordionProps> = ({ header, body }) => {
    const [isOpened, setIsOpened] = useState(true);
    const [wrapperHeight, setWrapperHeight] = useState<number | 'auto'>('auto');
    const headerRef = useRef<HTMLDivElement>(null);
    const bodyRef = useRef<HTMLUListElement>(null);

    const updateHeight = () => {
        const header = headerRef.current;
        const body = bodyRef.current;
        if (!header || !body) {
            return;
        }
        const headerHeight = header.getBoundingClientRect().height;
        const bodyHeight = isOpened ? body.getBoundingClientRect().height : 0;
        const offsets = isOpened ? WRAPPER_GAP + WRAPPER_PADDING * 2 : WRAPPER_PADDING * 2;
        setWrapperHeight(headerHeight + bodyHeight + offsets);
    };

    const handleToggleOpened = () => {
        setIsOpened(!isOpened);
    };

    useEffect(() => {
        updateHeight();
    }, [isOpened]);

    return (
        <Wrapper $height={wrapperHeight}>
            <Header ref={headerRef}>
                {header}
                <IconWrapper>
                    {isOpened ? (
                        <AllEye color={COLORS.neutral_50} onClick={handleToggleOpened} />
                    ) : (
                        <AllEyeClose color={COLORS.neutral_50} onClick={handleToggleOpened} />
                    )}
                </IconWrapper>
            </Header>
            <Body ref={bodyRef} isOpened={isOpened}>
                {body}
            </Body>
        </Wrapper>
    );
};
